var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        { attrs: { label: "类型" } },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.value.multiple,
                callback: function ($$v) {
                  _vm.$set(_vm.value, "multiple", $$v)
                },
                expression: "value.multiple",
              },
            },
            [
              _c("el-radio", { attrs: { label: false } }, [
                _c("span", { staticClass: "name-text" }, [
                  _vm._v("只能选择一个部门"),
                ]),
              ]),
              _c("el-radio", { attrs: { label: true } }, [
                _c("span", { staticClass: "name-text" }, [
                  _vm._v("可同时选择多个部门"),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }